<template>
  <section class="about-block" :id="anchorId">
    <div class="container">
      <h2 v-if="data.content.section_title">{{ data.content.section_title }}</h2>

      <div class="items-list">
        <AboutItem
          v-for="(item, index) in data.content.items"
          :key="index"
          :number="index + 1"
          :title="item.title"
          :content="item.content"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { provide, toRef } from 'vue'
import AboutItem from './About/AboutItem.vue';
import { useAnchorId } from '@/composables/useAnchorId';
import { useProximityTracking } from '@/composables/useProximityTracking';

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
});

const anchorId = useAnchorId(toRef(props, 'data'));

// Provide proximity tracking to all child components
const tracking = useProximityTracking()
provide('proximityTracking', tracking)
</script>

<style lang="scss" scoped>
.about-block {
  max-width: var(--main-width);
  margin-inline: var(--main-margin);
  overflow-x: hidden;
  border-radius: 4.25rem;
  background: var(--white);
  color: var(--dark);
  padding: 0;
  padding-bottom: 4rem;
}

.items-list {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  margin-top: -1rem;
}
</style>
